import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import SignatureManager from "../../components/SignatureManager";
import ReviewManager from "../../components/ReviewManager";
import CompanyAddress from "../../components/CompanyAddress";
import "../../styles/Form.css";
import logo from "../../images/logo.png";

const RecevingGeneralOrientation = () => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [username, setUsername] = useState("");
  const [dob, setDob] = useState("");
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();
  const { id: paramId } = useParams();
  const userRole = localStorage.getItem("userRole");
  const isAdmin = userRole === "1";
  const [isSigned, setIsSigned] = useState(false);
  const [signedDate, setSignedDate] = useState("");
  const effectiveUserId = isAdmin && paramId ? paramId : userId;

  useEffect(() => {
    const fetchUserName = async () => {
      try {
        const token = localStorage.getItem("token");
        const url = isAdmin
          ? `${API_BASE}/api/users/${effectiveUserId}`
          : `${API_BASE}/api/user/profile`;

        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const { first_name, last_name, dob } = res.data;
        setUsername(`${first_name} ${last_name}`);

        if (dob) {
          const date = new Date(dob);
          const formattedDob = `${(date.getMonth() + 1)
            .toString()
            .padStart(2, "0")}/${date
            .getDate()
            .toString()
            .padStart(2, "0")}/${date.getFullYear()}`;
          setDob(formattedDob);
        }
      } catch (err) {
        console.error("Error fetching user name:", err);
      }
    };

    const fetchTaskStatus = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/usertasks/status/${effectiveUserId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        const TASK_ID = 12; // verify this matches nwt_tasks.t_id for LEEP
        const idKey = String(TASK_ID);
        const nameKey = "receving_general_orientation";

        const status =
          res.data.status?.[idKey] ??
          res.data.status?.[nameKey] ??
          "not_completed";

        const signed = status === "review" || status === "completed";

        if (signed) {
          setIsSigned(true);
          setSignedDate(
            res.data.signdates?.[idKey] ?? res.data.signdates?.[nameKey]
          );
        }
      } catch (err) {
        console.error("Error checking task status:", err);
      }
    };

    fetchUserName();
    fetchTaskStatus();
  }, [API_BASE, userId, isAdmin, effectiveUserId]);

  const handleCancel = () => {
    if (isAdmin && paramId) {
      navigate(`/userhome/${paramId}`);
    } else {
      navigate("/userhome");
    }
  };

  return (
    <>
      {/* 🔝 Header Section with Status + Cancel Button */}
      <div className="d-flex justify-content-between align-items-center pt-3">
        <div className="d-flex align-items-center">
          <span className="me-2 text-danger"></span>
          <span style={{ fontSize: "18px", fontWeight: "500" }}>
            Acknowledgement of Receving General Orientation
          </span>
        </div>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancel}
        >
          Return
        </button>
      </div>
      <div
        className="form-wrapper my-4 print-area"
        style={{ fontSize: "15px", lineHeight: "1.6" }}
      >
        <div className="row align-items-center mb-4">
          <div className="col-3 text-start">
            <img
              src={logo}
              alt="Company Logo"
              style={{ width: "150px", height: "auto" }}
            />
          </div>
          <div className="col-6 text-center">
            <h2 className="m-0">
              {" "}
              Acknowledgement of Receving General Orientation
            </h2>
          </div>
          <CompanyAddress />
        </div>

        <p className="mt-4">
          I, <strong>{username}</strong>, born the date of; {dob}, have
          completed New Way Transport's New Employee Orientation and have read
          and understand the material covered within its contents.
        </p>

        <div className="container mt-4" style={{ backgroundColor: "#f4f5f7" }}>
          <div className="row">
            <div className="col-md-4">
              <ul className="list-unstyled">
                <li>Facility Orientation</li>
                <li>Drug and Alcohol Policy</li>
                <li>PPE Requirements</li>
                <li>Abstract Policy</li>
                <li>Driver Trip and Inspection Policy</li>
                <li>Travel Allowance Policy</li>
                <li>Proof of Delivery Policy</li>
                <li>Logbook Policy – ELD/Samara</li>
                <li>Trip Sheet Policy</li>
                <li>Employee Contract</li>
                <li>Camera Policy</li>
                <li>HACCP</li>
              </ul>
            </div>
            <div className="col-md-4">
              <ul className="list-unstyled">
                <li>Performance Expectations</li>
                <li>Tag Policy</li>
                <li>Key Café Policy</li>
                <li>Cargo Securement Policy</li>
                <li>Conditions of Deductions</li>
                <li>Code of Conduct</li>
                <li>Recording of Hours</li>
                <li>Environmental Policy</li>
                <li>
                  Responsibility and Accountability for Health and Safety Policy
                </li>
                <li>Rider Policy</li>
                <li>Winter Driving</li>
                <li>CP Rail Drayage</li>
                <li>Drivewyze</li>
              </ul>
            </div>
            <div className="col-md-4">
              <ul className="list-unstyled">
                <li>Zero Tolerance & Enforcement Policy</li>
                <li>Personal Vehicle Policies</li>
                <li>Safe Refueling Policy</li>
                <li>Spill Leak Emergency res</li>
                <li>Pet Policy</li>
                <li>Fuel Card Policy</li>
                <li>Training Cost Policy</li>
                <li>Sexual Harassment Policy</li>
                <li>Workplace Violence</li>
                <li>Reefer Training</li>
                <li>Dock Safety</li>
                <li>Weights & Dimensions</li>
                <li>CTPAT</li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-5">
          I have had the opportunity to ask questions about the policies, and I
          understand that any future questions that I may have about the above
          or information provided in New Way Transport's New Employee Orientation
          and its contents will be answered upon request.
        </p>

        <p className="mt-5">
          I agree to and will comply with the policies, procedures, and other
          guidelines set forth in the orientation.
        </p>

        <p className="mt-5">
          I understand that New Way Transport may change, modify, or abolish any
          or all of the policies, benefits, rules, and regulations contained or
          described in the orientation as it deems appropriate at any time, with
          or without notice. I acknowledge that neither the orientation nor its
          contents are an express or implied contract regarding my employment.
        </p>

        <hr className="my-5" />

        <form>
          <div className="row mb-3 mt-5">
            <div className="col">
              <label className="form-label">Employee Name</label>
              <input
                type="text"
                className="form-control"
                value={username}
                readOnly
              />
            </div>
            <div className="col">
              <label className="form-label">Date</label>
              <input
                type="text"
                className="form-control"
                value={
                  isSigned && signedDate
                    ? new Date(signedDate).toLocaleDateString()
                    : new Date().toLocaleDateString()
                }
                readOnly
              />
            </div>
          </div>
        </form>

        {userId && (
          <>
            <SignatureManager
              taskName="receving_general_orientation"
              taskId={12}
              userId={effectiveUserId}
              isAdmin={isAdmin}
            />
            <ReviewManager
              taskName="resume"
              taskId={12}
              userId={effectiveUserId}
              isAdmin={isAdmin}
            />
          </>
        )}
      </div>
    </>
  );
};

export default RecevingGeneralOrientation;
